/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_DismissInputs */



/**
* | output |
* | --- |
* | "Hide this tip" |
*
* @param {Nudge_DismissInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_dismiss = /** @type {((inputs?: Nudge_DismissInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_DismissInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verberg deze tip")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Masquer ce conseil")
	return /** @type {LocalizedString} */ ("Hide this tip")
});